import { render, staticRenderFns } from "./CategoryStep.vue?vue&type=template&id=6bcad1be&scoped=true&"
import script from "./CategoryStep.vue?vue&type=script&lang=js&"
export * from "./CategoryStep.vue?vue&type=script&lang=js&"
import style0 from "./CategoryStep.vue?vue&type=style&index=0&id=6bcad1be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bcad1be",
  null
  
)

export default component.exports